<template>
  <div class="pagePFont updateMessage">
    <Header title="手机号码修改" />
    <UpdateMsg :showAll="false" :btnText="confirmText" @click="handleConfirm">
      <div slot="form">
        <van-cell-group :border="false" v-if="first">
          <van-field
            v-model="phone"
            readonly
            placeholder="请输入用户姓名"
            label="原手机号码"
          >
          </van-field>
          <van-field
            v-model="code"
            clearable
            label="短信验证码"
            placeholder="请输入验证码"
            maxlength="8"
            :id="'oldcode'"
          >
            <template #button>
              <van-button
                slot="button"
                :disabled="disabled"
                size="small"
                type="primary"
                color="var(--depYelColor)"
                @click="getCode"
                >{{ codeText }}</van-button
              >
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false" v-else>
          <van-field
            v-model="newPhone"
            label="新手机号码"
            placeholder="请输入新的手机号"
            type="tel"
            maxlength="11"
            :id="'newphone'"
          >
          </van-field>

          <van-field
            v-model="newCode"
            clearable
            label="短信验证码"
            placeholder="请输入验证码"
            maxlength="8"
            :id="'newcode'"
          >
            <template #button>
              <van-button
                slot="button"
                :disabled="disabled"
                size="small"
                type="primary"
                color="var(--depYelColor)"
                @click="getCode"
                >{{ codeText }}</van-button
              >
            </template>
          </van-field>
        </van-cell-group>
      </div>
    </UpdateMsg>
    <Tips
      :showTitle="false"
      v-if="remark <= 2 && remark > 0"
      :content="
        '温馨提示：您的ID修改手机号码只剩余' + remark + '次，请谨慎操作。'
      "
    />
  </div>
</template>

<script>
import UpdateMsg from "common/UpdateMsg";
import { getPhoneCode } from "api/user";
// import { updateUserInfo } from "api/submit";
export default {
  components: {
    UpdateMsg,
  },
  data() {
    return {
      first: true,
      phone: "",
      newPhone: null,
      code: "",
      codeText: "获取验证码",
      newCode: "",
      disabled: false,
      confirmText: "下一步",
      remark: "",
    };
  },
  created() {
    this.getCode = this.$debounce(this.getCode);
  },
  mounted() {
    this.remark = this.$route.query.count;
    this.phone = this.$route.query.phone;
  },
  methods: {
    getCode() {
      let phone = null;
      if (this.first) {
        if (!this.phone) {
          this.$error("手机号码不能为空");
          return false;
        }
        phone = this.phone;
      } else {
        if (!this.newPhone) {
          this.$error("新手机号码不能为空");
          return false;
        }
        if (!this.$regPhone(this.newPhone)) {
          this.$error("新手机号码格式不对");
          return false;
        }
        phone = this.newPhone;
      }
      if (this.phone === this.newPhone) {
        this.$error("两次输入的手机号码不能一致");
        return false;
      }
      this.disabled = true;
      getPhoneCode(phone, this.first ? "getcheckcode" : "getupdatecheckcode")
        .then((res) => {
          if (res.status === 1) {
            this.downTime();
            this.$success("发送成功");
          } else {
            this.disabled = false;
            this.$error(res.message);
          }
        })
        .catch(() => {});
    },
    downTime() {
      let time = 59;
      let interval = setInterval(() => {
        if (time > 0) {
          let changeTime = time--;
          if (time < 10 && time > 0) {
            changeTime = "0" + time;
          }
          this.codeText = changeTime + "秒后获取";
        } else {
          clearInterval(interval);
          this.disabled = false;
          this.codeText = "获取验证码";
        }
      }, 1000);
      this.interval = interval;
    },
    async handleConfirm() {
      if (this.first) {
        if (!this.code) {
          this.$error("请输入验证码");
          document.getElementById("oldcode").focus();
          return false;
        }
        this.handlePhoneCode();
      } else {
        if (!this.newPhone) {
          this.$error("请输入新手机号");
          document.getElementById("newphone").focus();
          return false;
        }
        if (!this.$regPhone(this.newPhone)) {
          this.$error("新手机号码格式不对");
          return false;
        }
        if (!this.newCode) {
          this.$error("请输入新手机号短信验证码");
          document.getElementById("newcode").focus();
          return false;
        }
        this.confirm();
      }
    },
    // 手机验证码的验证
    handlePhoneCode() {
      // updateUserInfo(this.phone, this.code, "", "", "confirmcode").then(
      //   (res) => {
      //     if (res.status === 1) {
      //       this.first = false;
      //       this.disabled = false;
      //       clearInterval(this.interval);
      //       this.codeText = "获取验证码";
      //       this.confirmText = "确定";
      //     } else {
      //         this.$error(res.message);
      //     }
      //   }
      // );
    },
    confirm() {
      if (this.$regPhone(this.newPhone)) {
        // updateUserInfo(
        //   "",
        //   this.newCode,
        //   "",
        //   this.newPhone,
        //   "updateuserphone"
        // ).then((res) => {
        //   if (res.status === 1) {
        //     this.$successSync("修改成功", () => {
        //       // this.$back(-1)
        //       this.$push({
        //         path: "/user",
        //       });
        //     });
        //   } else {
        //     this.$error(res.message);
        //   }
        // });
      } else {
        this.$error("新手机号码格式错误");
      }
    },
  },
};
</script>

<style scoped lang="less">
.pagesTips {
  text-align: center;
  color: red;
}
.van-cell {
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-bottom: 15px;
  line-height: 48px;
  padding: initial;
  /deep/.van-field__label {
    color: #333;
    border-right: 1px solid #d7d7d7;
    text-align: right;
    padding-right: 8px;
  }
  /deep/.van-field__value {
    color: #000;
    padding-right: 8px;
  }
}
</style>
